// import React from "react";
// import { AuditHistory } from "../../../../../components";

// export const AuditHistoryList = () => {
//   return (
//     <div>
//       <AuditHistory />
//     </div>
//   );
// };

import React from "react";
import { AuditHistory } from "../../../../../components";

const AuditHistoryList = () => {
  return <div>{/* <AuditHistory /> */}asdf</div>;
};

export default AuditHistoryList;
